import type { SupportedLocaleType } from '../../locales';

export interface IEnglishIqResultImgCopy {
  hook: string;
  landingTitle: string;
}

const COPY_BY_LOCALE: Readonly<Record<SupportedLocaleType, IEnglishIqResultImgCopy>> =
  Object.freeze({
    en: { hook: 'Can you beat my score?', landingTitle: 'What is your English IQ?' },
    zh: { hook: '你能超过我的分数吗？', landingTitle: '你的 English IQ 是多少？' },
    hi: {
      hook: 'क्या आप मेरे स्कोर को हरा सकते हैं?',
      landingTitle: 'आपका English IQ कितना है?',
    },
    es: { hook: '¿Puedes superar mi puntuación?', landingTitle: '¿Cuál es tu English IQ?' },
    ar: { hook: 'هل يمكنك التفوق على نتيجتي؟', landingTitle: 'ما درجة English IQ لديك؟' },
    fr: { hook: 'Pouvez-vous battre mon score ?', landingTitle: 'Quel est ton English IQ ?' },
    bn: {
      hook: 'আপনি কি আমার স্কোরকে হারাতে পারবেন?',
      landingTitle: 'আপনার English IQ কত?',
    },
    pt: {
      hook: 'Você consegue superar minha pontuação?',
      landingTitle: 'Qual é o seu English IQ?',
    },
    ru: { hook: 'Сможете побить мой результат?', landingTitle: 'Какой у вас English IQ?' },
    ur: { hook: 'کیا آپ میرے اسکور کو ہرا سکتے ہیں؟', landingTitle: 'آپ کا English IQ کتنا ہے؟' },
    de: {
      hook: 'Kannst du meinen Punktestand schlagen?',
      landingTitle: 'Wie hoch ist dein English IQ?',
    },
    fa: { hook: 'می‌توانی امتیاز من را شکست بدهی؟', landingTitle: 'English IQ تو چند است؟' },
    it: { hook: 'Riesci a battere il mio punteggio?', landingTitle: 'Qual è il tuo English IQ?' },
  });

export function getEnglishIqResultImgCopy(locale: SupportedLocaleType): IEnglishIqResultImgCopy {
  return COPY_BY_LOCALE[locale];
}
